module.exports = "/_next/static/images/er-804cbebd72e805855091721b15486dba.svg";